import CheckIcon from '@material-ui/icons/Check';
import Styled from './styles';
export default ({ formStatus, step }) => {
  return (
    <Styled>
      <div
        className={`step-item ${step === 1 ? 'active' : ''} ${
          formStatus[1] === 'done' ? 'form-done' : ''
        }`}
      >
        {formStatus[1] !== 'done' ? (
          <span className="step-number">1</span>
        ) : (
          <div className="check-wrap">
            <CheckIcon
              sx={{ width: '24px', height: '24px', color: '#1565C0' }}
            />
          </div>
        )}
        <span className="step-label">基本信息</span>
      </div>
      <div className="step-line"></div>
      <div
        className={`step-item ${step === 2 ? 'active' : ''} ${
          formStatus[2] === 'done' ? 'form-done' : ''
        }`}
      >
        {formStatus[2] !== 'done' ? (
          <span className="step-number">2</span>
        ) : (
          <div className="check-wrap">
            <CheckIcon
              sx={{ width: '24px', height: '24px', color: '#1565C0' }}
            />
          </div>
        )}
        <span className="step-label">奖品设置</span>
      </div>
      <div className="step-line"></div>
      <div
        className={`step-item ${step === 3 ? 'active' : ''} ${
          formStatus[3] === 'done' ? 'form-done' : ''
        }`}
      >
        {formStatus[3] !== 'done' ? (
          <span className="step-number">3</span>
        ) : (
          <div className="check-wrap">
            <CheckIcon
              sx={{ width: '24px', height: '24px', color: '#1565C0' }}
            />
          </div>
        )}
        <span className="step-label">样式设置</span>
      </div>
    </Styled>
  );
};
